export const maxTextAreaInputLength = 2000;

export const phoneMask = "(000) 000-0000";

export const emailRegex: RegExp = /^([_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z0-9-]{2,5}))$/;

export const phoneRegex = RegExp(/^\+?[0-9]{10,11}$/);
